type DownloadExtensionType = {
  [key in DownloadExtension]: string;
};

export const DOWNLOAD_EXTENSION_TYPE: DownloadExtensionType = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
